import { useState } from "react";
import { Link } from "react-scroll";
import {
  Box,
  Flex,
  Avatar,
  HStack,
  IconButton,
  Button,
  Menu,
  MenuButton,
  useDisclosure,
  useColorModeValue,
  Stack,
  useColorMode,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon, MoonIcon, SunIcon } from "@chakra-ui/icons";
import styles from "./Css/Navbar.module.css";

// const Links = ["Home", "About Me", "Tech Stack", "Projects", "Contact"];

// const NavLink = ({ children }) => (
//   <Links
//     px={2}
//     py={1}
//     rounded={"md"}
//     _hover={{
//       textDecoration: "none",
//       bg: useColorModeValue("gray.200", "gray.700"),
//     }}
//     href={"#"}
//   >
//     {children}
//   </Links>
// );

export default function Simple() {
  const { colorMode, toggleColorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [click, setClick] = useState(false);
  const closeMenu = () => setClick(false);
  console.log(click);

  return (
    <>
      <Box
       bg={useColorModeValue('gray.100', 'gray.900')}
        px={4}
        className={styles.Navbar}
      >
        <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
          <IconButton
            size={"md"}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={"Open Menu"}
            display={{ md: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={"center"}>
            <Box>
              <Avatar size={"lg"} src={"image/logo Ashish Kohad.png"} />
            </Box>
            <HStack
              as={"nav"}
              spacing={4}
              display={{ base: "none", md: "flex" }}
              className={styles.NavbarTitle}
            >

              <Link
                to="home"
                spy={true}
                smooth={true}
                offset={-150}
                duration={500}
                onClick={closeMenu}
              >
                Home
              </Link>

              <Link
                to="aboutme"
                spy={true}
                smooth={true}
                offset={-5}
                duration={500}
                onClick={closeMenu}
              >
                {" "}
                About Me
              </Link>

              <Link
                to="projects"
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
                onClick={closeMenu}
              >
                Projects
              </Link>
              <Link
                to="github"
                spy={true}
                smooth={true}
                offset={-60}
                duration={500}
                onClick={closeMenu}
              >
                Github
              </Link>
              <Link
                to="techstack"
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
                onClick={closeMenu}
              >
                Skills
              </Link>

              <Link
                to="contact"
                spy={true}
                smooth={true}
                offset={120}
                duration={500}
                onClick={closeMenu}
              >
                Contact
              </Link>
              <a
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
                onClick={closeMenu}
                href="Resume/Ashish_Kohad_Resume.pdf"
                download="Ashish_Kohad_Resume"
              >
                Resume
              </a>
            </HStack>
          </HStack>

          <Flex alignItems={"center"}>
            <Menu>
              <Button mr="20px" onClick={toggleColorMode}>
                {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
              </Button>
              <MenuButton
                as={Button}
                rounded={"full"}
                variant={"link"}
                cursor={"pointer"}
                minW={0}
              >
                <Avatar
                  size={"sm"}
                  src={
                    "https://avatars.githubusercontent.com/u/107983345?s=64&v=4"
                  }
                />
              </MenuButton>
            </Menu>
          </Flex>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: "none" }}>
            <Stack as={"nav"} spacing={4}>
              {/* {Links.map((link) => (
                                <NavLink key={link}>{link}</NavLink>
                            ))} */}
              <Link
                to="home"
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
                onClick={closeMenu}
              >
                Home
              </Link>

              <Link
                to="aboutme"
                spy={true}
                smooth={true}
                offset={-5}
                duration={500}
                onClick={closeMenu}
              >
                {" "}
                About Me
              </Link>

              <Link
                to="projects"
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
                onClick={closeMenu}
              >
                Projects
              </Link>

              <Link
                to="techstack"
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
                onClick={closeMenu}
              >
                Skills
              </Link>

              <Link
                to="contact"
                spy={true}
                smooth={true}
                offset={-150}
                duration={500}
                onClick={closeMenu}
              >
                Contact
              </Link>
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
}
